import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Sentry from "@sentry/react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { setContext } from "@/app/sentry";
import { lazyRoute } from "@/lib/lazyRoute";
import LoginPage from "@/pages/auth/LoginPage";
import AuthenticatedRoutes from "./AuthenticatedRoutes";
const Demo = lazyRoute(() => import("@/pages/demo"));
const ResetPassword = lazyRoute(() => import("@/pages/auth/PasswordReset"));
const ForgotPassword = lazyRoute(() => import("@/pages/auth/ForgotPassword"));
const Confirm = lazyRoute(() => import("@/pages/auth/Confirm"));
export default function AppRoutes() {
    return (_jsx(BrowserRouter, { children: _jsx(Sentry.ErrorBoundary, { beforeCapture: () => setContext(), children: _jsxs(Routes, { children: [_jsx(Route, { path: "/login", element: _jsx(LoginPage, {}) }), _jsx(Route, { path: "/forgot-password", element: _jsx(ForgotPassword, {}) }), _jsx(Route, { path: "/password-reset/:token", element: _jsx(ResetPassword, {}) }), _jsx(Route, { path: "/confirm", element: _jsx(Confirm, {}) }), _jsx(Route, { path: "/demo/*", element: _jsx(Demo, {}) }), _jsx(Route, { path: "/*", element: _jsx(AuthenticatedRoutes, {}) })] }) }) }));
}
